import { render, staticRenderFns } from "./Toolbox.vue?vue&type=template&id=1d51fa3a&scoped=true&"
import script from "./Toolbox.vue?vue&type=script&lang=js&"
export * from "./Toolbox.vue?vue&type=script&lang=js&"
import style0 from "./Toolbox.vue?vue&type=style&index=0&id=1d51fa3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d51fa3a",
  null
  
)

export default component.exports